import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13e0d2d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { Ref, computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import Tooltip from "./tooltip.vue";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'globalToastMessage',
  setup(__props) {

const toast: Ref<IToastMessage> = ref({} as IToastMessage);

const activeCallApi = computed(() => store.state.User.activeCallApi);

watch(
  () => activeCallApi.value,
  (newValue) => {
    if (!newValue) {
      closeToast();
    }
  },
);

const watchEventToastMessage = () => {
  EventEmitter.on(
    EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE,
    async (data: any) => {
      const activeCallApi = store.state.User.activeCallApi;
      if (
        (!activeCallApi && data.variant === ToastVariant.ERROR) ||
        !data.message
      ) {
        return;
      }
      if (toast.value.message !== "") {
        closeToast();
        await new Promise((resolve) => setTimeout(resolve, 200));
      }

      data.message && (toast.value.message = ref(data.message));
      data.variant && (toast.value.variant = ref(data.variant));
      data.iconSrc && (toast.value.iconSrc = ref(data.iconSrc));
      data.delay && (toast.value.delay = ref(data.delay));
      data.uniqueId && (toast.value.uniqueId = ref(data.uniqueId));
      data.linkText && (toast.value.linkText = ref(data.linkText));
      data.redirectLink && (toast.value.redirectLink = ref(data.redirectLink));
    },
  );
};

const clearWatchEventToastMessage = () => {
  EventEmitter.off(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE);
};

const closeToast = () => {
  toast.value.message = "";
  toast.value.variant = "";
  toast.value.iconSrc = "";
  toast.value.delay = undefined;
  toast.value.uniqueId = "";
  toast.value.linkText = "";
  toast.value.redirectLink = "";
};

onMounted(() => {
  watchEventToastMessage();
});

onBeforeUnmount(() => {
  clearWatchEventToastMessage();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tooltip, {
    id: "global-tooltip",
    "data-cy": "global-tooltip",
    variant: toast.value.variant,
    show: !!toast.value.message,
    delay: toast.value.delay,
    onClose: closeToast
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(toast.value.message), 1),
      _createTextVNode("  "),
      (toast.value.redirectLink && toast.value.linkText)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            _createElementVNode("a", {
              href: toast.value.redirectLink
            }, _toDisplayString(toast.value.linkText), 9, _hoisted_2),
            _createTextVNode(".")
          ]))
        : _createCommentVNode("", true),
      _hoisted_3
    ]),
    _: 1
  }, 8, ["variant", "show", "delay"]))
}
}

})